module.exports = {
  "country": "NL",
  "artist": "Edsilia Rombley",
  "song": "Hemel & Aarde",
  "year": "1998",
  "place": "4",
  "spotify": "16kFUvzMPTUEcE4rQjT2n5"
};